import { cx } from '@flowus/common/cx';
import { Button } from '@flowus/login/uikit/web/button';
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
import type { FC } from 'react';
import { useCallback, useEffect, useRef, useState } from 'react';
import { LoadingContainer } from 'src/common/components/loading-container';
import { useCloseModal, useOpenModal } from 'src/common/components/next-modal';
import { downloadUrlFile } from 'src/common/utils/download-utils';
import { useCurrentUser } from 'src/hooks/user';
import { useUserName } from 'src/hooks/user/use-remark-name';
import { Images } from 'src/image';
import { bizTracker } from 'src/utils/biz-tracker';
import { v4 } from 'uuid';

const modalId = v4();
interface ShareQrProps {
  url: string;
  title: string;
}
const ShareQr: FC<ShareQrProps> = (props) => {
  const { url, title } = props;
  const [qrCode, setQrCode] = useState<string>('');
  const [imageResource, setImageResource] = useState<string>('');
  const currentUser = useCurrentUser();
  const userName = useUserName(currentUser.uuid);
  const ref = useRef<HTMLDivElement>(null);

  const closeModal = useCloseModal();

  const onCloseModal = () => {
    closeModal(modalId);
  };

  useEffect(() => {
    void (async () => {
      // 二维码url
      const _qr = await QRCode.toDataURL(`${url}`, {
        errorCorrectionLevel: 'H',
      });
      setQrCode(_qr);
    })();
  }, [currentUser.avatar, currentUser.backgroundColor, currentUser.nickname, url]);

  useEffect(() => {
    if (ref.current) {
      void html2canvas(ref.current, {
        useCORS: true,
        scale: 5,
        backgroundColor: null,
      }).then((canvas) => {
        const res = canvas.toDataURL('image/png', 1);
        setImageResource(res);
      });
    }
  }, [qrCode]);

  const download = () => {
    void downloadUrlFile(imageResource, `${Date.now()}.jpeg`);
  };

  return (
    <div className="next-modal w-125">
      <div className="h-20 flex items-center px-8">二维码分享</div>
      <div className="flex justify-center px-20 min-h-[500px]">
        {imageResource && <img className="absolute z-10 w-[340px]" src={imageResource} alt="" />}
        {qrCode ? (
          <div className={cx('relative w-[350px] mt-2', imageResource && 'opacity-0')} ref={ref}>
            <img className="" src={Images.shareFormQr} />
            <div className="absolute inset-0 px-12 py-6">
              <div className="flex py-2.5 text-t2-medium mb-5">
                {/* canvas画不出来头像，先隐藏了 */}
                {/* <Avatar
                  className="mr-2 mb-0.5 w-9 h-9 mt-2.5"
                  imgClassName="rounded-full"
                  name={userName}
                  icon={
                    currentUser?.avatar ? { type: 'upload', value: currentUser.avatar } : undefined
                  }
                  color={currentUser?.backgroundColor}
                /> */}
                <div>
                  <div className="text-black-base text-t1-medium">{userName}</div>
                  <div className="text-grey3-base text-t3">{title}</div>
                </div>
              </div>
              <img src={qrCode} className="w-60 h-60 mx-auto" />
            </div>
          </div>
        ) : (
          <LoadingContainer style={{ minHeight: 500 }} />
        )}
      </div>
      <div className="flex items-center justify-end h-24 px-8">
        <Button className="mr-2.5" onClick={() => onCloseModal()}>
          取消
        </Button>
        <Button colorType="active" onClick={download}>
          下载图片
        </Button>
      </div>
    </div>
  );
};

export const useOpenShareLinkQr = () => {
  const openModal = useOpenModal();
  return useCallback(
    (params: ShareQrProps) => {
      bizTracker.event('click_share_btn', {
        type: 'qr',
      });
      openModal.modal({
        modalId,
        content: () => <ShareQr {...params} />,
      });
    },
    [openModal]
  );
};
